// vue
import { useStore } from '@/store';

// mapbox
import mapboxgl from 'mapbox-gl';

export const useCategoryIconHooks = () => {
    const { apiUrl } = useStore().state;

    const initGeoRecordStyle = async (
        map: mapboxgl.Map,
        allCategoryIcon: any[],
    ) => {
        let iconImageFilter = ['match', ['get', 'geoRecordCategoryId']];

        allCategoryIcon = allCategoryIcon.filter(function (el) {
            return el.iconFileName != null;
        });

        await allCategoryIcon.forEach(async (symbolObject) => {
            // load svg
            let img = new Image(40, 40);
            img.onload = () => {
                if (map.hasImage(symbolObject.iconFileName)) return;
                map.addImage(symbolObject.iconFileName, img);
            };
            img.crossOrigin = 'anonymous';
            img.src = `${apiUrl}/assets/geo-record-icons/${symbolObject.iconFileName}`;
            iconImageFilter.push(symbolObject.id);
            iconImageFilter.push(symbolObject.iconFileName);
        });

        iconImageFilter.push('');

        map.addLayer({
            id: 'map-icons',
            type: 'symbol',
            source: 'geo-records',
            layout: {
                'icon-image': iconImageFilter,
                'icon-size': [
                    'interpolate',
                    ['exponential', 0.5],
                    ['zoom'],
                    10,
                    0.2,
                    20,
                    0.4,
                ],
            },
            filter: [
                'all',
                ['==', ['get', 'isVisible'], true],
                ['==', ['geometry-type'], 'Point'],
            ],
            minzoom: 14,
        });
    };
    return {
        initGeoRecordStyle,
    };
};
